var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitamediaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 10,
    viewBox: "0 0 84 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2205 2.01221H26.7852H27.3216L30.5401 9.49391H29.2132L26.7852 3.45208L25.2606 7.09412H26.7005L26.3052 8.0258H24.95L24.3289 9.49391H23.002L26.2205 2.01221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4385 2.01221H11.6807V9.49391H10.4385V2.01221Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0901 3.08505H4.14204V9.49391H2.89979V3.08505H0.5V2.01221H6.54183L6.0901 3.08505Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.138 3.08505H19.1899V9.49391H17.9476V3.08505H15.5479V2.01221H21.5897L21.138 3.08505Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6411 2.01221L39.5209 6.0495L42.4006 2.01221H43.5017V9.49391H42.2877V3.90381L39.662 7.51761H39.3797L36.7541 3.90381V9.49391H35.54V2.01221H36.6411Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2168 2.01221V3.08505H49.716V5.31545H51.7487L51.3535 6.3036H49.7442V8.44929H53.2451V9.49391H48.502V2.01221H53.2168Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9318 2.46393C63.4964 2.74626 63.9482 3.16975 64.2587 3.73441C64.5693 4.29907 64.7104 4.94842 64.7104 5.73894C64.7104 6.50123 64.5693 7.17882 64.2587 7.74347C63.9482 8.30813 63.5247 8.73162 62.96 9.04218C62.3953 9.35275 61.7178 9.49391 60.9555 9.49391H58.2451V2.01221H60.9272C61.6895 2.01221 62.3671 2.15337 62.9318 2.46393ZM62.7341 7.74347C63.1859 7.29175 63.4117 6.61416 63.4117 5.73894C63.4117 4.86372 63.1859 4.21437 62.7341 3.76264C62.2824 3.31092 61.6331 3.08505 60.7578 3.08505H59.4591V8.44929H60.8143C61.6331 8.44929 62.2824 8.1952 62.7341 7.74347Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7104 2.01221H70.9527V9.49391H69.7104V2.01221Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1712 2.01221H79.7076H79.7358H80.2723L83.4908 9.49391H82.1639L79.7358 3.45208L78.2113 7.09412H79.6511L79.2841 8.0258H77.9007L77.2796 9.49391H75.9526L79.1712 2.01221Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitamediaLogo);
export default __webpack_public_path__ + "static/media/titamedia-logo.20b7462d8ddf2435f2cd670955610c6e.svg";
export { ForwardRef as ReactComponent };